import { makeLoanPayroll } from 'src/main/factories/pages'

export default makeLoanPayroll
